import {cloneDeep} from "lodash";

export const ANALYSIS_CLOSE_ALL_MODALS = "ANALYSIS_CLOSE_ALL_MODALS";
export const ANALYSIS_OPEN_EDIT_MODAL = "ANALYSIS_OPEN_EDIT_MODAL";

const closedModalState = {
    edit: false,
    delete: false,
    projectId: null
};

const initialState = {
    analysisModals: cloneDeep(closedModalState),
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ANALYSIS_CLOSE_ALL_MODALS:
            return {...state, analysisModals: cloneDeep(closedModalState)};
        case ANALYSIS_OPEN_EDIT_MODAL:
            return {
                ...state,
                analysisModals: {
                    edit: true,
                    delete: false,
                    projectId: action.projectId,
                }};
        default:
            return state;
    }
};





// WEBPACK FOOTER //
// ./src/scenes/analysis/data/ProjectList/reducer.js